<div class="main-wrapper">
  <span class="header1">New Project</span>
  <div class="field-wrapper">
    <span class="label">Project Name</span>
    <input type="text" id="pname" name="pname" [(ngModel)]="projectName" />
  </div>
  {{ projectName }}
  <button (click)="onStart()">Start</button>
</div>
